
<template>
<div>
  <v-overlay :value="isLoading">
       <v-progress-circular
         indeterminate
         size="74"
       ></v-progress-circular>
     </v-overlay>
     <div><v-btn  @click="backTodisciplinList" class="mx-2" fab dark color="primary"><v-icon dark>arrow_back</v-icon></v-btn><iframe  style="width:100%;height:805px" :src="readfile"  title="SoftlineAngola"></iframe></div>
</div>
  </template>

<script>
import axios from '../../../../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    logotipo: ls.get('logotipo'),
    readImage2: ls.get('urlReport') + `readfile/`,
    configuracoesReport: [],
    isLoading: false,
    readfile: '',
    backTo: null,
    disciplina: ls.get('disciplinaobj')
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    role () {
      return ls.get('role')
    },
    isIlha () {
      return (ls.get('i_id') === 24 ? 1 : 0)
    }
  },

  watch: {
  },
  created () {
    this.$store.state.objturma = ls.get('disciplinasDaTurma')
    this.comporHtmlFicha()
  },

  methods: {
    async gerarPdf (option) {
      try {
        let result = await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: option
          }
        }).then((res) => res.data)
        this.isLoading = false
         this.readfile = ls.get('urlReport') + 'readfile/' + ls.get('nomeUsuario') + '.pdf'
       } catch (error) {
        
        this.isLoading = false
      }
    },
    backTodisciplinList () {
      this.$router.push('minipauta24')
    },
    async comporHtmlFicha () {
      try {
        let option = { 'format': 'A4',
          'orientation': 'landscape',
          'border': {
            'right': '5mm',
            'left': '5mm'
          },
          'header': {
            'height': '2mm' },
          'footer': {
            'height': '2mm'
          } }
        let linha = ``
        let i = 1
        let notas = (this.$store.state.minipauta.filter(t => t.iddisciplina === this.disciplina.iddisciplina)[0].notas)

        notas.forEach(element => {
          let mac = (this.disciplina.trimestre.idTrimestre === 1 ? (element.t1_mac === null ? '' : element.t1_mac) : this.disciplina.trimestre.idTrimestre === 2 ? (element.t2_mac === null ? '' : element.t2_mac) : this.disciplina.trimestre.idTrimestre === 3 ? (element.t3_mac === null ? '' : element.t3_mac) : '')
          linha += `
            <tr>
      <!-- Número -->
      <td> ` + (i++) + ` </td>

      <!-- Nome -->
      <td class="td-nome"> ` + element.nome + ` </td>

      <!-- Mês 1 -->
      <td></td>
      <td></td>
      <td> </td>
      <td></td>
      <td> </td>

      <!-- Primeiro MAC -->
      <td> ` + mac + ` </td>

      <!-- Mês 2 -->
      <td></td>
      <td></td>
      <td> </td>
      <td></td>
      <td> </td>

      <!-- Segundo MAC -->
      <td> ` + mac + ` </td>

      <!-- Mês 3 -->
      <td></td>
      <td></td>
      <td> </td>
      <td></td>
      <td> </td>

      <!-- Terceiro MAC -->
      <td> ` + mac + ` </td>

      <!-- Mês 4 -->
      <td></td>
      <td></td>
      <td> </td>
      <td></td>
      <td> </td>

      <!-- MAC/T -->
      <td> ` + mac + ` </td>

      <!-- OBS -->
      <td> 0 </td> 
    </tr>
            `
        })
        this.html = `
<html>
<head>
  <style>
    * {
      box-sizing: border-box;
    }

    body {
      font-family: Arial, Helvetica, sans-serif;
    }

    .row {
      margin-left: -5px;
      margin-right: -5px;
    }

    .row::after {
      content: "";
      clear: both;
      display: table;
    }

    .row .column {
      float: left;
      width: 70%;
      padding: 5px;
    }

    .column2 table, table007 {
      width: 100%;
      
    }

    .row .column table,
    .row .column th,
    .row .column td {
      border: 1 solid #808080;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 9px;
    }

    .column2 table,
    .column2 td {
      border: 1 solid #808080;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 9px;
    }

    .table007,
    .table007 td,
    .table007 th {
      border: 1 solid #808080;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 9px;
    }

    .table007 td,
    .table007 th {
      text-align: center;
    }

    .table007 td.td-nome {
      text-align: justify;
    }

    .removeborder {
      border: 0px;
    }

    .tabela3,
    .tabela3 tr,
    .tabela3 td {
      text-align: center;
      border: 2 solid #808080;
      font-size: 9px;
    }

  </style>
</head>
<body>
  <div class="row">
    <div class="column">
      <table style="border-collapse: collapse;">
        <tr>
          <td width="20%" class="removeborder"><img src='` + this.logotipo + `'  alt="" style="width:50px;height:30px;display: block;margin-left: auto;margin-right: auto;"></td>
          <td width="80%" class="removeborder"> ` + ls.get('instituicaodescricao').toUpperCase() + ` </td>
        </tr>
      </table>
    </div>

    <div class="column2">
        <table style="border-collapse: collapse;">
            <tr>
                <td style="font-weight:bold;width:40%;" class="removeborder">
                    Mapa de controlo das Avaliações Contínuas <br>
                    Período ` + this.$store.state.objturma.periodo + ` <br>
                    Disciplina: ` + this.disciplina.descricao + `
                </td>
                <td style="width:30%;text-align:left;" class="removeborder">
                    Curso: ` + this.$store.state.objturma.curso + `<br>
                    Classe: ` + this.disciplina.classe + ` <br>
                    Trimestre: ` + this.disciplina.trimestre.descricao + `
                </td>
                <td style="width:30%;text-align:left;" class="removeborder">
                    Turma:  ` + this.$store.state.objturma.turma + `<br>
                    Professor:_________________________________________________ <br>
                    Ano Lectivo:  ` + this.$store.state.objturma.anoLectivo + `
                </td>
            </tr
        </table>
    </div>
  </div>

  <table class="table007" style="border-collapse: collapse;">
    <tr>
      <td rowspan="2" width="4%">Nº</td>
      <td rowspan="2" width="36%">Nome</td>
      <td colspan="25" width="60%">Meses</td>
    </tr>
    <tr>
      <th colspan="5" width="10%">Mês 1</th>
      <th width="5%">MAC</th>
      <th colspan="5" width="10%">Mês 2</th>
      <th width="5%">MAC</th>
      <th colspan="5" width="10%">Mês 3</th>
      <th width="5%">MAC</th>
      <th colspan="5" width="10%">Mês 4</th>
      <th width="5%">MAC/T</th>
      <th width="10%">OBS</th>
    </tr
   ` + linha + `
  </table> <br>

  <table class="tabela3" style="border-collapse: collapse;">
    <tr>
      <td> </td>
      <td>Escala de Avaliação</td>
      <td>Escala de Avaliação contínua</td>
      <td>Notas prováveis</td>
      <td>Factor de conversao</td>
      <td>onv. De</td>
      <td>Classif.</td>
    </tr
    <tr>
      <td> </td>
      <td rowspan="9">0 - 20</td>
      <td rowspan="9">1 - 5</td>
      <td>1</td>
      <td rowspan="9">4</td>
      <td>1x4</td>
      <td>4</td>
    </tr>
    <tr>
      <td> </td>
      <td>1,5</td>
      <td>1,5x4</td>
      <td>6</td>
    </tr
    <tr>
      <td> </td>
      <td>2</td>
      <td>2x4</td>
      <td>8</td>
    </tr>
    <tr>
      <td> </td>
      <td>2,5</td>
      <td>2,5x4</td>
      <td>10</td>
    </tr
    <tr>
      <td> </td>
      <td>3</td>
      <td>3x4</td>
      <td>12</td>
    </tr>
    <tr>
      <td> </td>
      <td>3,5</td>
      <td>3,5x4</td>
      <td>14</td>
    </tr
    <tr>
      <td> </td>
      <td>4</td>
      <td>4x4</td>
      <td>16</td>
    </tr>
    <tr>
      <td> </td>
      <td>4,5</td>
      <td>4,5x4</td>
      <td>18</td>
    </tr
    <tr>
      <td> </td>
      <td>5</td>
      <td>5x4</td>
      <td>20</td>
    </tr>
  </table>
</body>
</html> `
        this.gerarPdf(option)
      } catch (error) {
        console.log(error)
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }

  }
}
</script>
